function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { sdkLogger } from '../../../logger';
import { createErrorLoggingObservable } from '../../../utils/observables/error-logging-observable';
import { ThumbnailPrefetchFactory } from './thumbnail-prefetch/thumbnail-prefetch-factory';
var DEFAULT_NUMBER_OF_SLE_THUMBNAILS_FOR_WINDOW = 1;
var MAX_NUMBER_OF_SLE_THUMBNAILS_FOR_WINDOW = 6;
var MAX_REPRESENTATIVE_TIME_PERIOD_SEC = 20;
export var BaseThumbnailManager = /*#__PURE__*/ function() {
    "use strict";
    function BaseThumbnailManager(config) {
        var _this = this;
        _class_call_check(this, BaseThumbnailManager);
        var _this1 = this;
        _define_property(this, "logger", sdkLogger.withContext('ThumbnailManager'));
        _define_property(this, "prefetchController", void 0);
        _define_property(this, "lastGivenThumbnail", null);
        _define_property(this, "availableVariants", []);
        _define_property(this, "chosenStreamSegments", []);
        _define_property(this, "hasVariantBeenChosen", false);
        _define_property(this, "NEXT_PREV_TILE_AMOUNT", 2);
        _define_property(this, "sleThumbnailConfig", null);
        _define_property(this, "availableThumbnailVariantsChanged", createErrorLoggingObservable('AvailableThumbnailVariantsChanged', this.logger));
        _define_property(this, "getNumberOfThumbnailsPerRequest", function(requestedQuantity) {
            if (requestedQuantity !== undefined && (requestedQuantity < 1 || requestedQuantity > MAX_NUMBER_OF_SLE_THUMBNAILS_FOR_WINDOW)) {
                _this.logger.warn("getNumberOfThumbnailsPerRequest: quantity is not in range of 1 to ".concat(MAX_NUMBER_OF_SLE_THUMBNAILS_FOR_WINDOW));
                return DEFAULT_NUMBER_OF_SLE_THUMBNAILS_FOR_WINDOW;
            }
            return requestedQuantity !== null && requestedQuantity !== void 0 ? requestedQuantity : DEFAULT_NUMBER_OF_SLE_THUMBNAILS_FOR_WINDOW;
        });
        _define_property(this, "getRepresentativePosition", function(position, representativeThumbnailTimePeriod) {
            if (representativeThumbnailTimePeriod) {
                if (representativeThumbnailTimePeriod > 1 && representativeThumbnailTimePeriod < MAX_REPRESENTATIVE_TIME_PERIOD_SEC) {
                    return position - position % representativeThumbnailTimePeriod;
                } else {
                    _this.logger.warn("Thumbnail Time Period is not in range of 1 to ".concat(MAX_REPRESENTATIVE_TIME_PERIOD_SEC));
                }
            } else {
                return position;
            }
        });
        _define_property(this, "pushPrevNextThumbnail", function(thumbnail, previousSleThumbnails, nextSleThumbnails, velocitySecondsPerSecond) {
            var imageTile = {
                url: thumbnail.url,
                startPosition: thumbnail.startPosition,
                duration: thumbnail.duration
            };
            if (velocitySecondsPerSecond) {
                if (velocitySecondsPerSecond > 0) {
                    nextSleThumbnails.push(imageTile);
                } else {
                    previousSleThumbnails.push(imageTile);
                }
            }
        });
        _define_property(this, "getSleThumbnailsForTime", /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(timeIncludingAds, contentTime, velocitySecondsPerSecond) {
                var _this_sleThumbnailConfig, currentThumbnail, previousSleThumbnails, nextSleThumbnails, numberOfThumbnails, position, i, _this_sleThumbnailConfig1, _this_getRepresentativePosition, adjustedPosition, thumbnail;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            currentThumbnail = null;
                            previousSleThumbnails = [];
                            nextSleThumbnails = [];
                            numberOfThumbnails = velocitySecondsPerSecond ? _this1.getNumberOfThumbnailsPerRequest((_this_sleThumbnailConfig = _this1.sleThumbnailConfig) === null || _this_sleThumbnailConfig === void 0 ? void 0 : _this_sleThumbnailConfig.thumbnailsPerRequest) : 1;
                            // velocitySecondsPerSecond is required for requesting more than one thumbnail URL
                            position = timeIncludingAds;
                            i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(i < numberOfThumbnails)) return [
                                3,
                                4
                            ];
                            adjustedPosition = (_this_getRepresentativePosition = _this1.getRepresentativePosition(position, (_this_sleThumbnailConfig1 = _this1.sleThumbnailConfig) === null || _this_sleThumbnailConfig1 === void 0 ? void 0 : _this_sleThumbnailConfig1.sleThumbnailRepresentativeTimePeriod)) !== null && _this_getRepresentativePosition !== void 0 ? _this_getRepresentativePosition : position;
                            return [
                                4,
                                _this1.nativeGetThumbnailForTime(adjustedPosition, contentTime, velocitySecondsPerSecond)
                            ];
                        case 2:
                            thumbnail = _state.sent();
                            if (i === 0) {
                                currentThumbnail = thumbnail;
                            } else if (thumbnail) {
                                _this1.pushPrevNextThumbnail(thumbnail, previousSleThumbnails, nextSleThumbnails, velocitySecondsPerSecond);
                            } else {
                                return [
                                    3,
                                    4
                                ];
                            }
                            if (numberOfThumbnails) {
                                position += velocitySecondsPerSecond !== null && velocitySecondsPerSecond !== void 0 ? velocitySecondsPerSecond : 0;
                                if (position < 0) {
                                    position = 0;
                                }
                            }
                            _state.label = 3;
                        case 3:
                            i++;
                            return [
                                3,
                                1
                            ];
                        case 4:
                            return [
                                2,
                                currentThumbnail ? {
                                    previousTiles: previousSleThumbnails,
                                    currentThumbnail: currentThumbnail,
                                    nextTiles: nextSleThumbnails
                                } : null
                            ];
                    }
                });
            });
            return function(timeIncludingAds, contentTime, velocitySecondsPerSecond) {
                return _ref.apply(this, arguments);
            };
        }());
        var _config_sleThumbnailConfig;
        this.sleThumbnailConfig = (_config_sleThumbnailConfig = config === null || config === void 0 ? void 0 : config.sleThumbnailConfig) !== null && _config_sleThumbnailConfig !== void 0 ? _config_sleThumbnailConfig : null;
        if (config === null || config === void 0 ? void 0 : config.shouldDisableThumbnailsPrefetch) {
            return;
        }
        this.prefetchController = ThumbnailPrefetchFactory.createThumbnailPrefetchController();
    }
    _create_class(BaseThumbnailManager, [
        {
            key: "isLive",
            value: function isLive() {
                return false;
            }
        },
        {
            key: "onAvailableThumbnailVariantsChanged",
            value: function onAvailableThumbnailVariantsChanged(callback, callbackOwner) {
                this.availableThumbnailVariantsChanged.registerObserver(callback.bind(callbackOwner), callbackOwner);
            }
        },
        {
            key: "notifyAvailableThumbnailVariantsChanged",
            value: function notifyAvailableThumbnailVariantsChanged(thumbnailVariants) {
                this.availableVariants = thumbnailVariants;
                if (CoreVideoInternal.capabilities.hasThumbnailScrubbingSupport()) {
                    this.availableThumbnailVariantsChanged.notifyObservers(thumbnailVariants);
                }
            }
        },
        {
            key: "handlePlayerLoaded",
            value: function handlePlayerLoaded() {
                if (!this.isLive()) {
                    var // Only prefetch thumbnails if stream is not live. Live thumbnails are fetched on-demand
                    _this_prefetchController;
                    (_this_prefetchController = this.prefetchController) === null || _this_prefetchController === void 0 ? void 0 : _this_prefetchController.handlePlayerLoaded();
                }
            }
        },
        {
            key: "setThumbnailVariant",
            value: function setThumbnailVariant(variantId) {
                var _this = this;
                return _async_to_generator(function() {
                    var chosenStream, hasBeenSetSuccessfully;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                chosenStream = _this.availableVariants.find(function(param) {
                                    var id = param.id;
                                    return id === variantId;
                                });
                                if (!chosenStream) {
                                    _this.logger.warn('Given Variant is invalid');
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    4,
                                    _this.nativeSetThumbnailVariant(variantId)
                                ];
                            case 1:
                                hasBeenSetSuccessfully = _state.sent();
                                _this.hasVariantBeenChosen = hasBeenSetSuccessfully;
                                return [
                                    2,
                                    hasBeenSetSuccessfully
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getThumbnailForTime",
            value: function getThumbnailForTime(timeIncludingAds, contentTime, velocitySecondsPerSecond) {
                var _this = this;
                return _async_to_generator(function() {
                    var currentThumbnail;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.hasVariantBeenChosen) {
                                    _this.logger.warn('No Thumbnail Variant chosen. Will not return thumbnail.');
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                if (!_this.isLive()) return [
                                    3,
                                    1
                                ];
                                return [
                                    2,
                                    _this.getSleThumbnailsForTime(timeIncludingAds, contentTime, velocitySecondsPerSecond)
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.nativeGetThumbnailForTime(timeIncludingAds, contentTime)
                                ];
                            case 2:
                                currentThumbnail = _state.sent();
                                return [
                                    2,
                                    _this.buildAndStoreThumbnailRenderInfo(currentThumbnail)
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_prefetchController;
                (_this_prefetchController = this.prefetchController) === null || _this_prefetchController === void 0 ? void 0 : _this_prefetchController.destroy();
                this.nativeDestroy();
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(callbackOwner) {
                this.availableThumbnailVariantsChanged.unregisterObservers(callbackOwner);
            }
        },
        {
            key: "checkIsInBounds",
            value: function checkIsInBounds(position, elementInfo) {
                var endPosition = elementInfo.startPosition + elementInfo.duration;
                return position >= elementInfo.startPosition && position < endPosition;
            }
        },
        {
            key: "buildAndStoreThumbnailRenderInfo",
            value: function buildAndStoreThumbnailRenderInfo(currentThumbnail) {
                if (currentThumbnail === null) {
                    return null;
                }
                var segmentIndex = this.chosenStreamSegments.findIndex(function(segment) {
                    return segment.tileUrl === currentThumbnail.url;
                });
                var startPreviousSegmentIndex = Math.max(0, segmentIndex - this.NEXT_PREV_TILE_AMOUNT);
                var previousSegments = this.chosenStreamSegments.slice(startPreviousSegmentIndex, segmentIndex);
                var endNextSegmentIndex = Math.min(this.chosenStreamSegments.length, segmentIndex + 1 + this.NEXT_PREV_TILE_AMOUNT);
                var nextSegments = this.chosenStreamSegments.slice(segmentIndex + 1, endNextSegmentIndex);
                var thumbnailRenderInfo = {
                    previousTiles: this.buildImageObjectsFromSegments(previousSegments.reverse()),
                    currentThumbnail: currentThumbnail,
                    nextTiles: this.buildImageObjectsFromSegments(nextSegments)
                };
                return thumbnailRenderInfo;
            }
        },
        {
            key: "buildImageObjectsFromSegments",
            value: function buildImageObjectsFromSegments(segments) {
                return segments.map(function(segment) {
                    return {
                        url: segment.tileUrl,
                        startPosition: segment.startPosition,
                        duration: segment.duration
                    };
                });
            }
        }
    ]);
    return BaseThumbnailManager;
}();

//# sourceMappingURL=base-thumbnail-manager.js.map